import Header from '../components/Header';
import Footer from '../components/Footer';
import GlobalIcons from '../components/GlobalIcons';

const AppShell = ({
    children,
    showHeader = false,
    showFooter = false,
    headerProps = {},
    footerProps = {}
}) => {
    return (
        <div className="app-shell">
            <Header show={showHeader} {...headerProps} />

            <div className="app-shell__body">
                {children}
            </div>

            <Footer show={showFooter} {...footerProps} />

            <GlobalIcons />
        </div>
    );
};

export default AppShell;
